import { Project, Task, Subtask, SubSubtask, ReviewHistory } from '../types';

export const mockProject: Project = {
  id: '1',
  name: '美容師平台',
  description: '打造全方位的美容師服務平台，整合預約、電商、肌膚檢測等功能，提供美容師與客戶最佳的互動體驗。',
  status: 'active',
  startDate: new Date('2024-01-15'),
  expectedDate: new Date('2024-06-30'),
  progress: 42,
  expectedProgress: 75,
  pmName: '李美玲',
  issueCount: 2,
  tasks: [
    {
      id: 'task-1',
      title: '註冊功能',
      description: '實現美容師和客戶的註冊流程，包含身份驗證、資料填寫、技能認證等功能。',
      priority: 'high',
      pmName: '張志明',
      startDate: new Date('2024-01-20'),
      expectedDate: new Date('2024-03-15'),
      progress: 65,
      expectedProgress: 85,
      roles: ['UI', 'UX', '前端', '後端', '系統架構師'],
      discussionCount: 15,
      isCollapsed: false,
      subtasks: [
        {
          id: 'subtask-1-1',
          text: '設計會員登入/註冊頁面UI',
          role: 'UI',
          status: 'review-failed',
          assignees: ['李志偉', '王美玲'],
          startDate: new Date('2024-02-05'),
          expectedDate: new Date('2024-02-15'),
          actualCompletedDate: undefined,
          discussionCount: 3,
          subSubtasks: [
            {
              id: 'subsubtask1-1',
              text: '設計登入表單樣式',
              completed: true,
              timeLogs: [
                {
                  id: 'timelog1-1-1',
                  date: new Date('2024-02-05'),
                  hours: 3,
                  assignee: '李志偉',
                  description: '初步設計登入表單',
                  createdAt: new Date('2024-02-05'),
                },
                {
                  id: 'timelog1-1-2',
                  date: new Date('2024-02-06'),
                  hours: 2,
                  assignee: '王美玲',
                  description: '調整表單配色與間距',
                  createdAt: new Date('2024-02-06'),
                }
              ],
            },
            {
              id: 'subsubtask1-2',
              text: '設計註冊流程界面',
              completed: true,
              timeLogs: [
                {
                  id: 'timelog1-2-1',
                  date: new Date('2024-02-07'),
                  hours: 4,
                  assignee: '李志偉',
                  description: '設計多步驟註冊流程',
                  createdAt: new Date('2024-02-07'),
                }
              ],
            },
            {
              id: 'subsubtask1-3',
              text: '設計密碼重設頁面',
              completed: false,
              timeLogs: [
                {
                  id: 'timelog1-3-1',
                  date: new Date('2024-02-08'),
                  hours: 2.5,
                  assignee: '王美玲',
                  description: '設計密碼重設表單',
                  createdAt: new Date('2024-02-08'),
                }
              ],
            }
          ],
          reviewHistory: [
            {
              id: 'review1-1',
              reviewCount: 1,
              date: new Date('2024-02-09'),
              reason: '初次提交設計稿供審核',
              passed: false
            },
            {
              id: 'review1-2',
              reviewCount: 1,
              date: new Date('2024-02-10T10:30:00'),
              reason: '登入表單的按鈕顏色與品牌色不符，註冊流程需要簡化步驟',
              passed: false
            },
            {
              id: 'review1-3',
              reviewCount: 2,
              date: new Date('2024-02-12'),
              reason: '根據審核意見修改後重新提交',
              passed: false
            },
            {
              id: 'review1-4',
              reviewCount: 2,
              date: new Date('2024-02-13T14:15:00'),
              reason: '密碼重設頁面缺少郵件驗證步驟的設計',
              passed: false
            }
          ],
          timeLogs: [
            {
              id: 'timelog1-main-1',
              date: new Date('2024-02-05'),
              hours: 1.5,
              assignee: '李志偉',
              description: '需求分析與設計規劃',
              createdAt: new Date('2024-02-05'),
            },
            {
              id: 'timelog1-main-2',
              date: new Date('2024-02-11'),
              hours: 3,
              assignee: '李志偉',
              description: '根據審核意見修改設計',
              createdAt: new Date('2024-02-11'),
            },
            {
              id: 'timelog1-main-3',
              date: new Date('2024-02-11'),
              hours: 2,
              assignee: '王美玲',
              description: '協助修改配色方案',
              createdAt: new Date('2024-02-11'),
            }
          ],
        },
        {
          id: 'subtask-1-2',
          text: '實作前端註冊邏輯',
          role: '前端',
          status: 'completed',
          assignees: ['吳明憲', '周杰倫'],
          startDate: new Date('2024-02-05'),
          expectedDate: new Date('2024-02-20'),
          actualCompletedDate: new Date('2024-02-18'),
          discussionCount: 5,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-5', date: new Date('2024-02-06'), hours: 6, assignee: '吳明憲', description: 'React元件架構設計', createdAt: new Date('2024-02-06') },
            { id: 'tl-6', date: new Date('2024-02-07'), hours: 8, assignee: '吳明憲', description: '表單元件實作', createdAt: new Date('2024-02-07') },
            { id: 'tl-7', date: new Date('2024-02-08'), hours: 4, assignee: '周杰倫', description: '樣式調整與RWD', createdAt: new Date('2024-02-08') },
            { id: 'tl-8', date: new Date('2024-02-09'), hours: 7, assignee: '周杰倫', description: '動畫效果實作', createdAt: new Date('2024-02-09') },
            { id: 'tl-8a', date: new Date('2024-02-10'), hours: 3, assignee: '李志偉', description: 'UI元件整合協助', createdAt: new Date('2024-02-10') },
            { id: 'tl-8b', date: new Date('2024-02-11'), hours: 5, assignee: '王小明', description: '代碼審查與優化', createdAt: new Date('2024-02-11') },
            { id: 'tl-8c', date: new Date('2024-02-12'), hours: 4, assignee: '黃俊傑', description: '元件效能優化', createdAt: new Date('2024-02-12') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-1-3',
          text: 'API設計與實作',
          role: '後端',
          status: 'review-failed',
          assignees: ['陳大明', '張小華'],
          startDate: new Date('2024-02-20'),
          expectedDate: new Date('2024-03-05'),
          discussionCount: 8,
          subSubtasks: [],
          timeLogs: [],
          reviewHistory: [
            {
              id: 'review-1',
              reviewCount: 1,
              date: new Date('2024-03-03'),
              passed: false,
              reason: 'API回應格式不符規範'
            }
          ]
        },
        {
          id: 'subtask-1-4',
          text: '資料庫設計',
          role: '系統架構師',
          status: 'reviewing',
          assignees: ['黃建華'],
          startDate: new Date('2024-02-01'),
          expectedDate: new Date('2024-02-15'),
          discussionCount: 4,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-13', date: new Date('2024-02-02'), hours: 6, assignee: '劉建宏', description: '資料表結構設計', createdAt: new Date('2024-02-02') },
            { id: 'tl-14', date: new Date('2024-02-03'), hours: 5, assignee: '劉建宏', description: '關聯設計與正規化', createdAt: new Date('2024-02-03') },
            { id: 'tl-15', date: new Date('2024-02-04'), hours: 4, assignee: '許志成', description: '索引最佳化', createdAt: new Date('2024-02-04') },
            { id: 'tl-16', date: new Date('2024-02-05'), hours: 7, assignee: '許志成', description: 'Migration腳本撰寫', createdAt: new Date('2024-02-05') },
            { id: 'tl-16a', date: new Date('2024-02-06'), hours: 3, assignee: '黃建華', description: '資料庫架構審查', createdAt: new Date('2024-02-06') },
            { id: 'tl-16b', date: new Date('2024-02-07'), hours: 4, assignee: '陳大明', description: '效能測試與調整', createdAt: new Date('2024-02-07') },
            { id: 'tl-16c', date: new Date('2024-02-08'), hours: 2, assignee: '鄭文豪', description: '資料庫連線池設定', createdAt: new Date('2024-02-08') },
          ],
          reviewHistory: [
            {
              id: 'review-2',
              reviewCount: 1,
              date: new Date('2024-02-16'),
              passed: false,
              reason: '缺少必要索引'
            },
            {
              id: 'review-3',
              reviewCount: 2,
              date: new Date('2024-02-20'),
              passed: false,
              reason: '外鍵約束設計有誤'
            }
          ]
        },
        {
          id: 'subtask-1-5',
          text: '實作註冊API',
          role: '後端',
          status: 'pending',
          assignees: ['陳大明', '張小華'],
          expectedDate: new Date('2024-03-01'),
          discussionCount: 0,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-17a', date: new Date('2024-02-27'), hours: 6, assignee: '陳大明', description: 'API endpoint設計', createdAt: new Date('2024-02-27') },
            { id: 'tl-17b', date: new Date('2024-02-28'), hours: 5, assignee: '張小華', description: '商業邏輯實作', createdAt: new Date('2024-02-28') },
            { id: 'tl-17c', date: new Date('2024-02-28'), hours: 3, assignee: '劉建宏', description: '資料驗證邏輯', createdAt: new Date('2024-02-28') },
          ],
          reviewHistory: [],
        }
      ]
    },
    {
      id: 'task-2',
      title: '肌膚檢測功能',
      description: '開發AI驅動的肌膚狀態檢測功能，包含影像識別與分析報告',
      priority: 'high',
      startDate: new Date('2024-02-15'),
      expectedDate: new Date('2024-04-20'),
      progress: 30,
      pmName: '王小華',
      expectedProgress: 70,
      roles: ['UI', 'UX', '前端', '後端', 'AI工程師'],
      subtasks: [
        {
          id: 'subtask-2-1',
          text: '檢測介面設計',
          role: 'UX',
          status: 'completed',
          assignees: ['張筱雯'],
          startDate: new Date('2024-02-15'),
          expectedDate: new Date('2024-02-28'),
          actualCompletedDate: new Date('2024-02-26'),
          discussionCount: 2,
          subSubtasks: [],
          timeLogs: [],
          reviewHistory: [],
        },
        {
          id: 'subtask-2-2',
          text: '檢測流程設計',
          role: 'UX',
          status: 'in-progress',
          assignees: ['張筱雯', '林佩蓉'],
          startDate: new Date('2024-02-28'),
          expectedDate: new Date('2024-03-10'),
          discussionCount: 1,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-20', date: new Date('2024-02-28'), hours: 4, assignee: '張筱雯', description: '使用者流程圖設計', createdAt: new Date('2024-02-28') },
            { id: 'tl-21', date: new Date('2024-03-01'), hours: 3, assignee: '林佩蓉', description: 'Wireframe繪製', createdAt: new Date('2024-03-01') },
            { id: 'tl-22', date: new Date('2024-03-02'), hours: 5, assignee: '林佩蓉', description: '互動原型製作', createdAt: new Date('2024-03-02') },
            { id: 'tl-22a', date: new Date('2024-03-03'), hours: 3, assignee: '張筱雯', description: '原型審查與修改', createdAt: new Date('2024-03-03') },
            { id: 'tl-22b', date: new Date('2024-03-04'), hours: 2, assignee: '吳明憲', description: '前端可行性評估', createdAt: new Date('2024-03-04') },
            { id: 'tl-22c', date: new Date('2024-03-05'), hours: 4, assignee: '李志偉', description: '視覺風格建議', createdAt: new Date('2024-03-05') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-2-3',
          text: '訓練肌膚辨識模型',
          role: 'AI工程師',
          status: 'in-progress',
          assignees: ['楊智凱', '趙明華'],
          startDate: new Date('2024-03-01'),
          expectedDate: new Date('2024-03-30'),
          discussionCount: 3,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-23', date: new Date('2024-03-03'), hours: 8, assignee: '楊智凱', description: '資料集準備與清理', createdAt: new Date('2024-03-03') },
            { id: 'tl-24', date: new Date('2024-03-04'), hours: 6, assignee: '楊智凱', description: '模型架構設計', createdAt: new Date('2024-03-04') },
            { id: 'tl-25', date: new Date('2024-03-05'), hours: 7, assignee: '趙明華', description: '初版模型訓練', createdAt: new Date('2024-03-05') },
            { id: 'tl-26', date: new Date('2024-03-06'), hours: 5, assignee: '趙明華', description: '模型參數調整', createdAt: new Date('2024-03-06') },
            { id: 'tl-26a', date: new Date('2024-03-07'), hours: 4, assignee: '陳大明', description: 'API整合架構設計', createdAt: new Date('2024-03-07') },
            { id: 'tl-26b', date: new Date('2024-03-08'), hours: 6, assignee: '許志成', description: '模型部署環境準備', createdAt: new Date('2024-03-08') },
            { id: 'tl-26c', date: new Date('2024-03-09'), hours: 3, assignee: '黃建華', description: '系統架構審查', createdAt: new Date('2024-03-09') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-2-4',
          text: '建立分析算法',
          role: 'AI工程師',
          status: 'pending',
          assignees: ['楊智凱'],
          expectedDate: new Date('2024-04-15'),
          discussionCount: 0,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-26d', date: new Date('2024-03-10'), hours: 5, assignee: '楊智凱', description: '算法研究與設計', createdAt: new Date('2024-03-10') },
            { id: 'tl-26e', date: new Date('2024-03-11'), hours: 4, assignee: '趙明華', description: '算法原型實作', createdAt: new Date('2024-03-11') },
          ],
          reviewHistory: [],
        }
      ],
      discussionCount: 15,
      isCollapsed: false
    },
    {
      id: 'task-3',
      title: '電商功能',
      description: '整合商品展示、購物車與結帳功能，支援多種支付方式',
      priority: 'medium',
      startDate: new Date('2024-03-01'),
      expectedDate: new Date('2024-05-30'),
      progress: 45,
      pmName: '陳佳玲',
      expectedProgress: 50,
      roles: ['UI', 'UX', '前端', '後端', '系統架構師'],
      subtasks: [
        {
          id: 'subtask-3-1',
          text: '商品列表頁面',
          role: '系統架構師',
          status: 'completed',
          assignees: ['黃建華'],
          startDate: new Date('2024-03-01'),
          expectedDate: new Date('2024-03-10'),
          actualCompletedDate: new Date('2024-03-08'),
          discussionCount: 4,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-27', date: new Date('2024-03-02'), hours: 5, assignee: '黃建華', description: '系統架構規劃', createdAt: new Date('2024-03-02') },
            { id: 'tl-28', date: new Date('2024-03-03'), hours: 6, assignee: '黃建華', description: 'API設計文件撰寫', createdAt: new Date('2024-03-03') },
            { id: 'tl-28a', date: new Date('2024-03-04'), hours: 4, assignee: '鍾培生', description: '資料流程設計', createdAt: new Date('2024-03-04') },
            { id: 'tl-28b', date: new Date('2024-03-05'), hours: 3, assignee: '劉建宏', description: '資料庫架構建議', createdAt: new Date('2024-03-05') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-3-2',
          text: '購物車功能',
          role: '前端',
          status: 'in-progress',
          assignees: ['王小明', '李美玲'],
          startDate: new Date('2024-03-10'),
          expectedDate: new Date('2024-03-20'),
          actualCompletedDate: new Date('2024-03-18'),
          discussionCount: 3,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-29', date: new Date('2024-03-11'), hours: 4, assignee: '王小明', description: '購物車元件開發', createdAt: new Date('2024-03-11') },
            { id: 'tl-30', date: new Date('2024-03-12'), hours: 5, assignee: '李美玲', description: '狀態管理實作', createdAt: new Date('2024-03-12') },
            { id: 'tl-31', date: new Date('2024-03-13'), hours: 6, assignee: '王小明', description: '購物車API整合', createdAt: new Date('2024-03-13') },
            { id: 'tl-31a', date: new Date('2024-03-14'), hours: 3, assignee: '吳明憲', description: '程式碼審查與優化', createdAt: new Date('2024-03-14') },
            { id: 'tl-31b', date: new Date('2024-03-15'), hours: 4, assignee: '周杰倫', description: '效能優化', createdAt: new Date('2024-03-15') },
            { id: 'tl-31c', date: new Date('2024-03-16'), hours: 2, assignee: '黃俊傑', description: '單元測試撰寫', createdAt: new Date('2024-03-16') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-3-3',
          text: '結帳流程',
          role: '系統架構師',
          status: 'review-failed',
          assignees: ['黃建華', '鍾培生'],
          startDate: new Date('2024-04-01'),
          expectedDate: new Date('2024-04-15'),
          discussionCount: 6,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-32', date: new Date('2024-04-02'), hours: 7, assignee: '黃建華', description: '結帳流程架構設計', createdAt: new Date('2024-04-02') },
            { id: 'tl-33', date: new Date('2024-04-03'), hours: 4, assignee: '鍾培生', description: '金流整合規劃', createdAt: new Date('2024-04-03') },
            { id: 'tl-34', date: new Date('2024-04-04'), hours: 5, assignee: '黃建華', description: '訂單系統設計', createdAt: new Date('2024-04-04') },
            { id: 'tl-34a', date: new Date('2024-04-05'), hours: 6, assignee: '陳大明', description: '後端API協助設計', createdAt: new Date('2024-04-05') },
            { id: 'tl-34b', date: new Date('2024-04-06'), hours: 3, assignee: '劉建宏', description: '交易安全性審查', createdAt: new Date('2024-04-06') },
          ],
          reviewHistory: [
            {
              id: 'review-4',
              reviewCount: 1,
              date: new Date('2024-04-11'),
              passed: false,
              reason: '購物車數量更新邏輯有誤'
            }
          ]
        },
        {
          id: 'subtask-3-4',
          text: '串接金流服務',
          role: '後端',
          status: 'pending',
          assignees: ['鄭文豪', '張小華'],
          expectedDate: new Date('2024-05-01'),
          discussionCount: 2,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-34c', date: new Date('2024-04-07'), hours: 5, assignee: '鄭文豪', description: '金流SDK研究', createdAt: new Date('2024-04-07') },
            { id: 'tl-34d', date: new Date('2024-04-08'), hours: 4, assignee: '張小華', description: '支付介面設計', createdAt: new Date('2024-04-08') },
          ],
          reviewHistory: [],
        }
      ],
      discussionCount: 20,
      isCollapsed: false
    },
    {
      id: 'task-4',
      title: '預約功能',
      description: '建立服務預約系統，包含行事曆整合與提醒通知',
      priority: 'medium',
      startDate: new Date('2024-03-15'),
      expectedDate: new Date('2024-05-15'),
      progress: 25,
      pmName: '林俊傑',
      expectedProgress: 40,
      roles: ['UI', 'UX', '前端', '後端'],
      subtasks: [
        {
          id: 'subtask-4-1',
          text: '預約介面設計',
          role: 'UI',
          status: 'completed',
          assignees: ['李志偉'],
          startDate: new Date('2024-03-15'),
          expectedDate: new Date('2024-03-25'),
          actualCompletedDate: new Date('2024-03-23'),
          discussionCount: 3,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-35', date: new Date('2024-03-16'), hours: 5, assignee: '李志偉', description: '預約介面UI設計', createdAt: new Date('2024-03-16') },
            { id: 'tl-36', date: new Date('2024-03-17'), hours: 6, assignee: '李志偉', description: '互動效果設計', createdAt: new Date('2024-03-17') },
            { id: 'tl-36a', date: new Date('2024-03-18'), hours: 3, assignee: '陳美君', description: '協助圖標設計', createdAt: new Date('2024-03-18') },
            { id: 'tl-36b', date: new Date('2024-03-19'), hours: 2.5, assignee: '張筱雯', description: 'UX流程優化建議', createdAt: new Date('2024-03-19') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-4-2',
          text: '行事曆元件設計',
          role: 'UI',
          status: 'in-progress',
          assignees: ['李志偉'],
          startDate: new Date('2024-03-25'),
          expectedDate: new Date('2024-04-05'),
          discussionCount: 1,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-37', date: new Date('2024-03-26'), hours: 4, assignee: '李志偉', description: '行事曆視覺設計', createdAt: new Date('2024-03-26') },
            { id: 'tl-38', date: new Date('2024-03-27'), hours: 5, assignee: '李志偉', description: '日期選擇器設計', createdAt: new Date('2024-03-27') },
            { id: 'tl-38a', date: new Date('2024-03-28'), hours: 3, assignee: '陳美君', description: '色彩方案調整', createdAt: new Date('2024-03-28') },
            { id: 'tl-38b', date: new Date('2024-03-29'), hours: 4, assignee: '吳明憲', description: '前端元件可行性評估', createdAt: new Date('2024-03-29') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-4-3',
          text: '實作日曆選擇器',
          role: '前端',
          status: 'pending',
          assignees: ['吳明憲', '李美玲'],
          expectedDate: new Date('2024-04-20'),
          discussionCount: 2,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-38c', date: new Date('2024-03-30'), hours: 5, assignee: '吳明憲', description: '日曆元件架構設計', createdAt: new Date('2024-03-30') },
            { id: 'tl-38d', date: new Date('2024-03-31'), hours: 4, assignee: '李美玲', description: '日期邏輯處理', createdAt: new Date('2024-03-31') },
            { id: 'tl-38e', date: new Date('2024-04-01'), hours: 3, assignee: '陳大明', description: '後端API規格討論', createdAt: new Date('2024-04-01') },
          ],
          reviewHistory: [],
        },
        {
          id: 'subtask-4-4',
          text: '建立預約確認流程',
          role: '前端',
          status: 'pending',
          assignees: ['吳明憲', '王小明'],
          expectedDate: new Date('2024-05-10'),
          discussionCount: 0,
          subSubtasks: [],
          timeLogs: [
            { id: 'tl-38f', date: new Date('2024-04-02'), hours: 4, assignee: '吳明憲', description: '預約流程規劃', createdAt: new Date('2024-04-02') },
            { id: 'tl-38g', date: new Date('2024-04-03'), hours: 3, assignee: '王小明', description: '狀態管理設計', createdAt: new Date('2024-04-03') },
          ],
          reviewHistory: [],
        }
      ],
      discussionCount: 12,
      isCollapsed: false
    }
  ]
};

export const generateMockProject = (): Project => {
  const mockProject: Project = {
    id: '1',
    name: '美容師平台',
    description: '打造全方位的美容師服務平台，整合預約、電商、肌膚檢測等功能，提供美容師與客戶最佳的互動體驗。',
    startDate: new Date('2024-01-15'),

    
    progress: 42,
    status: 'active',
    expectedDate: new Date('2024-06-30'),
    expectedProgress: 75,
    pmName: '李美玲',
    issueCount: 8,
    tasks: [
      {
        id: 'task-1',
        title: '註冊功能',
        description: '實現美容師和客戶的註冊流程，包含身份驗證、資料填寫、技能認證等功能。',
        priority: 'high',
        startDate: new Date('2024-01-20'),
        expectedDate: new Date('2024-03-15'),
                progress: 65,
        pmName: '張志明',
        expectedProgress: 80,
        roles: ['UI', 'UX', '前端', '後端', '系統架構師'],
        subtasks: [
          {
            id: 'subtask-1-1',
            text: '設計會員登入/註冊頁面UI',
            role: 'UI',
            status: 'review-failed',
            assignees: ['李志偉', '王美玲'],
            startDate: new Date('2024-02-05'),
            expectedDate: new Date('2024-02-15'),
            actualCompletedDate: undefined,
            discussionCount: 3,
            subSubtasks: [
              {
                id: 'subsubtask1-1',
                text: '設計登入表單樣式',
                completed: true,
                timeLogs: [
                  {
                    id: 'timelog1-1-1',
                    date: new Date('2024-02-05'),
                    hours: 3,
                    assignee: '李志偉',
                    description: '初步設計登入表單',
                    createdAt: new Date('2024-02-05'),
                  },
                  {
                    id: 'timelog1-1-2',
                    date: new Date('2024-02-06'),
                    hours: 2,
                    assignee: '王美玲',
                    description: '調整表單配色與間距',
                    createdAt: new Date('2024-02-06'),
                  }
                ],
              },
              {
                id: 'subsubtask1-2',
                text: '設計註冊流程界面',
                completed: true,
                timeLogs: [
                  {
                    id: 'timelog1-2-1',
                    date: new Date('2024-02-07'),
                    hours: 4,
                    assignee: '李志偉',
                    description: '設計多步驟註冊流程',
                    createdAt: new Date('2024-02-07'),
                  }
                ],
              },
              {
                id: 'subsubtask1-3',
                text: '設計密碼重設頁面',
                completed: false,
                timeLogs: [
                  {
                    id: 'timelog1-3-1',
                    date: new Date('2024-02-08'),
                    hours: 2.5,
                    assignee: '王美玲',
                    description: '設計密碼重設表單',
                    createdAt: new Date('2024-02-08'),
                  }
                ],
              }
            ],
            reviewHistory: [
              {
                id: 'review1-1',
                reviewCount: 1,
                date: new Date('2024-02-09'),
                reason: '初次提交設計稿供審核',
                passed: false
              },
              {
                id: 'review1-2',
                reviewCount: 1,
                date: new Date('2024-02-10T10:30:00'),
                reason: '登入表單的按鈕顏色與品牌色不符，註冊流程需要簡化步驟',
                passed: false
              },
              {
                id: 'review1-3',
                reviewCount: 2,
                date: new Date('2024-02-12'),
                reason: '根據審核意見修改後重新提交',
                passed: false
              },
              {
                id: 'review1-4',
                reviewCount: 2,
                date: new Date('2024-02-13T14:15:00'),
                reason: '密碼重設頁面缺少郵件驗證步驟的設計',
                passed: false
              }
            ],
            timeLogs: [
              {
                id: 'timelog1-main-1',
                date: new Date('2024-02-05'),
                hours: 1.5,
                assignee: '李志偉',
                description: '需求分析與設計規劃',
                createdAt: new Date('2024-02-05'),
              },
              {
                id: 'timelog1-main-2',
                date: new Date('2024-02-11'),
                hours: 3,
                assignee: '李志偉',
                description: '根據審核意見修改設計',
                createdAt: new Date('2024-02-11'),
              },
              {
                id: 'timelog1-main-3',
                date: new Date('2024-02-11'),
                hours: 2,
                assignee: '王美玲',
                description: '協助修改配色方案',
                createdAt: new Date('2024-02-11'),
              }
            ],
          },
          {
            id: 'subtask-1-2',
            text: '實作前端註冊邏輯',
            role: '前端',
            status: 'completed',
            assignees: ['吳明憲', '周杰倫'],
            startDate: new Date('2024-02-05'),
            expectedDate: new Date('2024-02-20'),
            actualCompletedDate: new Date('2024-02-18'),
            discussionCount: 5,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-5', date: new Date('2024-02-06'), hours: 6, assignee: '吳明憲', description: 'React元件架構設計', createdAt: new Date('2024-02-06') },
              { id: 'tl-6', date: new Date('2024-02-07'), hours: 8, assignee: '吳明憲', description: '表單元件實作', createdAt: new Date('2024-02-07') },
              { id: 'tl-7', date: new Date('2024-02-08'), hours: 4, assignee: '周杰倫', description: '樣式調整與RWD', createdAt: new Date('2024-02-08') },
              { id: 'tl-8', date: new Date('2024-02-09'), hours: 7, assignee: '周杰倫', description: '動畫效果實作', createdAt: new Date('2024-02-09') },
              { id: 'tl-8a', date: new Date('2024-02-10'), hours: 3, assignee: '李志偉', description: 'UI元件整合協助', createdAt: new Date('2024-02-10') },
              { id: 'tl-8b', date: new Date('2024-02-11'), hours: 5, assignee: '王小明', description: '代碼審查與優化', createdAt: new Date('2024-02-11') },
              { id: 'tl-8c', date: new Date('2024-02-12'), hours: 4, assignee: '黃俊傑', description: '元件效能優化', createdAt: new Date('2024-02-12') },
            ],
            reviewHistory: [],
          },
          {
            id: 'subtask-1-3',
            text: 'API設計與實作',
            role: '後端',
            status: 'review-failed',
            assignees: ['陳大明', '張小華'],
            startDate: new Date('2024-02-20'),
            expectedDate: new Date('2024-03-05'),
            discussionCount: 8,
            subSubtasks: [],
            timeLogs: [],
            reviewHistory: [
              {
                id: 'review-1',
                reviewCount: 1,
                date: new Date('2024-03-03'),
                reason: 'API回應格式不符規範',
                passed: false,
              },
            ]
          },
          {
            id: 'subtask-1-4',
            text: '建立會員資料庫架構',
            role: '後端',
            status: 'reviewing',
            assignees: ['劉建宏', '許志成'],
            startDate: new Date('2024-02-01'),
            expectedDate: new Date('2024-02-15'),
            reviewHistory: [
              {
                id: 'review-2',
                reviewCount: 1,
                date: new Date('2024-02-16'),
                reason: '缺少必要索引',
                passed: false,
              },
              {
                id: 'review-3',
                reviewCount: 2,
                date: new Date('2024-02-20'),
                reason: '外鍵約束設計有誤',
                passed: false,
              },
            ],
            discussionCount: 4,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-13', date: new Date('2024-02-02'), hours: 6, assignee: '劉建宏', description: '資料表結構設計', createdAt: new Date('2024-02-02') },
              { id: 'tl-14', date: new Date('2024-02-03'), hours: 5, assignee: '劉建宏', description: '關聯設計與正規化', createdAt: new Date('2024-02-03') },
              { id: 'tl-15', date: new Date('2024-02-04'), hours: 4, assignee: '許志成', description: '索引最佳化', createdAt: new Date('2024-02-04') },
              { id: 'tl-16', date: new Date('2024-02-05'), hours: 7, assignee: '許志成', description: 'Migration腳本撰寫', createdAt: new Date('2024-02-05') },
              { id: 'tl-16a', date: new Date('2024-02-06'), hours: 3, assignee: '黃建華', description: '資料庫架構審查', createdAt: new Date('2024-02-06') },
              { id: 'tl-16b', date: new Date('2024-02-07'), hours: 4, assignee: '陳大明', description: '效能測試與調整', createdAt: new Date('2024-02-07') },
              { id: 'tl-16c', date: new Date('2024-02-08'), hours: 2, assignee: '鄭文豪', description: '資料庫連線池設定', createdAt: new Date('2024-02-08') },
            ]
          },
          {
            id: 'subtask-1-5',
            text: '實作註冊API',
            role: '後端',
            status: 'pending',
            assignees: ['陳大明', '張小華'],
            expectedDate: new Date('2024-03-01'),
            discussionCount: 0,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-17a', date: new Date('2024-02-27'), hours: 6, assignee: '陳大明', description: 'API endpoint設計', createdAt: new Date('2024-02-27') },
              { id: 'tl-17b', date: new Date('2024-02-28'), hours: 5, assignee: '張小華', description: '商業邏輯實作', createdAt: new Date('2024-02-28') },
              { id: 'tl-17c', date: new Date('2024-02-28'), hours: 3, assignee: '劉建宏', description: '資料驗證邏輯', createdAt: new Date('2024-02-28') },
            ],
            reviewHistory: [],
          },
        ],
        discussionCount: 15,
        isCollapsed: false,
      },
      {
        id: 'task-2',
        title: '肌膚檢測功能',
        description: '運用AI技術分析客戶肌膚狀況，提供專業的膚質分析報告和保養建議。',
        priority: 'high',
        startDate: new Date('2024-02-15'),
        expectedDate: new Date('2024-04-20'),
        progress: 30,
        pmName: '王小華',
        expectedProgress: 55,
        roles: ['UI', 'UX', '前端', '後端', 'AI工程師'],
        subtasks: [
          {
            id: 'subtask-2-1',
            text: '使用者訪談與需求分析',
            description: '進行用戶研究，了解需求',
            status: 'completed',
            role: 'UX',
            assignees: ['張筱雯'],
            startDate: new Date('2024-02-15'),
            expectedDate: new Date('2024-02-28'),
            actualCompletedDate: new Date('2024-02-26'),
            reviewHistory: [],
            discussionCount: 2,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-17', date: new Date('2024-02-16'), hours: 6, assignee: '張筱雯', description: '使用者訪談準備', createdAt: new Date('2024-02-16') },
              { id: 'tl-18', date: new Date('2024-02-17'), hours: 8, assignee: '張筱雯', description: '進行使用者訪談', createdAt: new Date('2024-02-17') },
              { id: 'tl-19', date: new Date('2024-02-18'), hours: 5, assignee: '張筱雯', description: '訪談結果分析整理', createdAt: new Date('2024-02-18') },
              { id: 'tl-19a', date: new Date('2024-02-19'), hours: 3, assignee: '林佩蓉', description: '協助訪談記錄整理', createdAt: new Date('2024-02-19') },
              { id: 'tl-19b', date: new Date('2024-02-20'), hours: 4, assignee: '陳美君', description: '使用者痛點分析', createdAt: new Date('2024-02-20') },
            ],
          },
          {
            id: 'subtask-2-2',
            text: '檢測流程設計',
            description: '設計肌膚檢測的用戶流程',
            status: 'in-progress',
            role: 'UX',
            assignees: ['張筱雯', '林佩蓉'],
            startDate: new Date('2024-02-28'),
            expectedDate: new Date('2024-03-10'),
            reviewHistory: [],
            discussionCount: 1,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-20', date: new Date('2024-02-28'), hours: 4, assignee: '張筱雯', description: '使用者流程圖設計', createdAt: new Date('2024-02-28') },
              { id: 'tl-21', date: new Date('2024-03-01'), hours: 3, assignee: '林佩蓉', description: 'Wireframe繪製', createdAt: new Date('2024-03-01') },
              { id: 'tl-22', date: new Date('2024-03-02'), hours: 5, assignee: '林佩蓉', description: '互動原型製作', createdAt: new Date('2024-03-02') },
              { id: 'tl-22a', date: new Date('2024-03-03'), hours: 3, assignee: '張筱雯', description: '原型審查與修改', createdAt: new Date('2024-03-03') },
              { id: 'tl-22b', date: new Date('2024-03-04'), hours: 2, assignee: '吳明憲', description: '前端可行性評估', createdAt: new Date('2024-03-04') },
              { id: 'tl-22c', date: new Date('2024-03-05'), hours: 4, assignee: '李志偉', description: '視覺風格建議', createdAt: new Date('2024-03-05') },
            ],
          },
          {
            id: 'subtask-2-3',
            text: '訓練肌膚辨識模型',
            description: '使用機器學習訓練肌膚分析模型',
            status: 'in-progress',
            role: 'AI工程師',
            assignees: ['楊智凱', '趙明華'],
            startDate: new Date('2024-03-01'),
            expectedDate: new Date('2024-03-30'),
            reviewHistory: [],
            discussionCount: 3,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-23', date: new Date('2024-03-03'), hours: 8, assignee: '楊智凱', description: '資料集準備與清理', createdAt: new Date('2024-03-03') },
              { id: 'tl-24', date: new Date('2024-03-04'), hours: 6, assignee: '楊智凱', description: '模型架構設計', createdAt: new Date('2024-03-04') },
              { id: 'tl-25', date: new Date('2024-03-05'), hours: 7, assignee: '趙明華', description: '初版模型訓練', createdAt: new Date('2024-03-05') },
              { id: 'tl-26', date: new Date('2024-03-06'), hours: 5, assignee: '趙明華', description: '模型參數調整', createdAt: new Date('2024-03-06') },
              { id: 'tl-26a', date: new Date('2024-03-07'), hours: 4, assignee: '陳大明', description: 'API整合架構設計', createdAt: new Date('2024-03-07') },
              { id: 'tl-26b', date: new Date('2024-03-08'), hours: 6, assignee: '許志成', description: '模型部署環境準備', createdAt: new Date('2024-03-08') },
              { id: 'tl-26c', date: new Date('2024-03-09'), hours: 3, assignee: '黃建華', description: '系統架構審查', createdAt: new Date('2024-03-09') },
            ],
          },
          {
            id: 'subtask-2-4',
            text: '建立分析算法',
            description: '開發肌膚分析算法',
            status: 'pending',
            role: 'AI工程師',
            assignees: ['楊智凱'],
            expectedDate: new Date('2024-04-15'),
            reviewHistory: [],
            discussionCount: 0,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-26d', date: new Date('2024-03-10'), hours: 5, assignee: '楊智凱', description: '算法研究與設計', createdAt: new Date('2024-03-10') },
              { id: 'tl-26e', date: new Date('2024-03-11'), hours: 4, assignee: '趙明華', description: '算法原型實作', createdAt: new Date('2024-03-11') },
            ],
          },
        ],
        discussionCount: 8,
        isCollapsed: false,
      },
      {
        id: 'task-3',
        title: '電商功能',
        description: '建立美容產品銷售平台，包含商品管理、購物車、金流串接等完整電商功能。',
        priority: 'medium',
        startDate: new Date('2024-03-01'),
        expectedDate: new Date('2024-05-30'),
        progress: 45,
        pmName: '陳佳玲',
        expectedProgress: 60,
        roles: ['UI', 'UX', '前端', '後端', '系統架構師'],
        subtasks: [
          {
            id: 'subtask-3-1',
            text: '設計商品資料庫架構',
            description: '規劃商品數據存儲結構',
            status: 'completed',
            role: '系統架構師',
            assignees: ['周大為'],
            startDate: new Date('2024-03-01'),
            expectedDate: new Date('2024-03-10'),
            actualCompletedDate: new Date('2024-03-08'),
            reviewHistory: [],
            discussionCount: 4,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-27', date: new Date('2024-03-02'), hours: 5, assignee: '黃建華', description: '系統架構規劃', createdAt: new Date('2024-03-02') },
              { id: 'tl-28', date: new Date('2024-03-03'), hours: 6, assignee: '黃建華', description: 'API設計文件撰寫', createdAt: new Date('2024-03-03') },
              { id: 'tl-28a', date: new Date('2024-03-04'), hours: 4, assignee: '鍾培生', description: '資料流程設計', createdAt: new Date('2024-03-04') },
              { id: 'tl-28b', date: new Date('2024-03-05'), hours: 3, assignee: '劉建宏', description: '資料庫架構建議', createdAt: new Date('2024-03-05') },
            ],
          },
          {
            id: 'subtask-3-2',
            text: '規劃訂單處理流程',
            description: '設計訂單管理系統',
            status: 'completed',
            role: '系統架構師',
            assignees: ['周大為'],
            startDate: new Date('2024-03-10'),
            expectedDate: new Date('2024-03-20'),
            actualCompletedDate: new Date('2024-03-18'),
            reviewHistory: [],
            discussionCount: 3,
            subSubtasks: [],
            timeLogs: []
          },
          {
            id: 'subtask-3-3',
            text: '實作購物車功能',
            description: '開發購物車前後端功能',
            status: 'review-failed',
            role: '後端',
            assignees: ['劉建宏'],
            startDate: new Date('2024-03-20'),
            expectedDate: new Date('2024-04-10'),
            reviewHistory: [
              {
                id: 'review-4',
                reviewCount: 1,
                date: new Date('2024-04-11'),
                reason: '購物車數量更新邏輯有誤',
                passed: false,
              },
            ],
            discussionCount: 5,
            subSubtasks: [],
            timeLogs: []
          },
          {
            id: 'subtask-3-4',
            text: '串接金流服務',
            description: '整合第三方支付系統',
            status: 'pending',
            role: '後端',
            assignees: ['鄭文豪', '張小華'],
            expectedDate: new Date('2024-05-01'),
            reviewHistory: [],
            discussionCount: 2,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-34c', date: new Date('2024-04-07'), hours: 5, assignee: '鄭文豪', description: '金流SDK研究', createdAt: new Date('2024-04-07') },
              { id: 'tl-34d', date: new Date('2024-04-08'), hours: 4, assignee: '張小華', description: '支付介面設計', createdAt: new Date('2024-04-08') },
            ],
          },
        ],
        discussionCount: 12,
        isCollapsed: false
      },
      {
        id: 'task-4',
        title: '預約功能',
        description: '提供客戶線上預約美容師服務，包含時間管理、預約提醒、評價系統等功能。',
        priority: 'medium',
        startDate: new Date('2024-03-15'),
        expectedDate: new Date('2024-05-15'),
        progress: 25,
        pmName: '林俊傑',
        expectedProgress: 35,
        roles: ['UI', 'UX', '前端', '後端'],
        subtasks: [
          {
            id: 'subtask-4-1',
            text: '設計預約介面流程',
            description: '設計預約系統的用戶界面',
            status: 'completed',
            role: 'UI',
            assignees: ['李志偉', '張筱雯'],
            startDate: new Date('2024-03-15'),
            expectedDate: new Date('2024-03-25'),
            actualCompletedDate: new Date('2024-03-23'),
            reviewHistory: [],
            discussionCount: 3,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-35', date: new Date('2024-03-16'), hours: 5, assignee: '李志偉', description: '預約介面UI設計', createdAt: new Date('2024-03-16') },
              { id: 'tl-36', date: new Date('2024-03-17'), hours: 6, assignee: '李志偉', description: '互動效果設計', createdAt: new Date('2024-03-17') },
              { id: 'tl-36a', date: new Date('2024-03-18'), hours: 3, assignee: '陳美君', description: '協助圖標設計', createdAt: new Date('2024-03-18') },
              { id: 'tl-36b', date: new Date('2024-03-19'), hours: 2.5, assignee: '張筱雯', description: 'UX流程優化建議', createdAt: new Date('2024-03-19') },
            ],
          },
          {
            id: 'subtask-4-2',
            text: '行事曆元件設計',
            role: 'UI',
            status: 'in-progress',
            assignees: ['李志偉'],
            startDate: new Date('2024-03-25'),
            expectedDate: new Date('2024-04-05'),
            discussionCount: 1,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-37', date: new Date('2024-03-26'), hours: 4, assignee: '李志偉', description: '行事曆視覺設計', createdAt: new Date('2024-03-26') },
              { id: 'tl-38', date: new Date('2024-03-27'), hours: 5, assignee: '李志偉', description: '日期選擇器設計', createdAt: new Date('2024-03-27') },
              { id: 'tl-38a', date: new Date('2024-03-28'), hours: 3, assignee: '陳美君', description: '色彩方案調整', createdAt: new Date('2024-03-28') },
              { id: 'tl-38b', date: new Date('2024-03-29'), hours: 4, assignee: '吳明憲', description: '前端元件可行性評估', createdAt: new Date('2024-03-29') },
            ],
            reviewHistory: [],
          },
          {
            id: 'subtask-4-3',
            text: '實作日曆選擇器',
            role: '前端',
            status: 'pending',
            assignees: ['吳明憲', '李美玲'],
            expectedDate: new Date('2024-04-20'),
            discussionCount: 2,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-38c', date: new Date('2024-03-30'), hours: 5, assignee: '吳明憲', description: '日曆元件架構設計', createdAt: new Date('2024-03-30') },
              { id: 'tl-38d', date: new Date('2024-03-31'), hours: 4, assignee: '李美玲', description: '日期邏輯處理', createdAt: new Date('2024-03-31') },
              { id: 'tl-38e', date: new Date('2024-04-01'), hours: 3, assignee: '陳大明', description: '後端API規格討論', createdAt: new Date('2024-04-01') },
            ],
            reviewHistory: [],
          },
          {
            id: 'subtask-4-4',
            text: '建立預約確認流程',
            role: '前端',
            status: 'pending',
            assignees: ['吳明憲', '王小明'],
            expectedDate: new Date('2024-05-10'),
            discussionCount: 0,
            subSubtasks: [],
            timeLogs: [
              { id: 'tl-38f', date: new Date('2024-04-02'), hours: 4, assignee: '吳明憲', description: '預約流程規劃', createdAt: new Date('2024-04-02') },
              { id: 'tl-38g', date: new Date('2024-04-03'), hours: 3, assignee: '王小明', description: '狀態管理設計', createdAt: new Date('2024-04-03') },
            ],
            reviewHistory: [],
          },
        ],
        discussionCount: 6,
        isCollapsed: false,
      },
    ],
  };

  return mockProject;
}; 